import React, { useEffect } from 'react';
import { Check, ShoppingCart } from 'lucide-react';
import './Toast.css';

const Toast = ({ message, show, onClose, duration = 2000, type = 'success', actionButton }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, onClose, duration]);

  if (!show) return null;

  return (
    <div className={`toast toast-${type} ${show ? 'toast-show' : ''}`}>
      <div className="toast-icon">
        {type === 'success' && <Check size={20} />}
        {type === 'cart' && <ShoppingCart size={20} />}
      </div>
      <div className="toast-message">{message}</div>
      {actionButton && (
        <button className="toast-action-btn" onClick={actionButton.onClick}>
          {actionButton.text}
        </button>
      )}
    </div>
  );
};

export default Toast;
